interface Props {
  successCount: number;
  errors: Array<{ fileName: string; message: string }>;
  durationSeconds: number;
  downloaded?: boolean;
  onReset: () => void;
}

export function ResultView({ successCount, errors, durationSeconds, downloaded = false, onReset }: Props) {
  const allOk = errors.length === 0;
  return (
    <div className="card">
      <div className="flex items-start justify-between gap-4 mb-3">
        <div>
          <h2 className={`text-xl font-semibold ${allOk ? "text-green-700" : "text-amber-700"}`}>
            {allOk ? "Fertig" : "Fertig (mit Fehlern)"}
          </h2>
          {downloaded ? (
            <p className="text-sm text-kampmeyer-neutral-500 mt-1">
              {successCount} Bild{successCount === 1 ? "" : "er"} skaliert und heruntergeladen ·{" "}
              {durationSeconds.toFixed(0)} s
            </p>
          ) : (
            <p className="text-sm text-kampmeyer-neutral-500 mt-1">
              {successCount} Bild{successCount === 1 ? "" : "er"} in
              <code className="mx-1 text-xs bg-kampmeyer-neutral-100 px-1.5 py-0.5 rounded">00_Skaliert</code>
              gespeichert · {durationSeconds.toFixed(0)} s
            </p>
          )}
        </div>
        <button onClick={onReset} className="btn-primary shrink-0">
          {downloaded ? "Neues Bild" : "Neuer Ordner"}
        </button>
      </div>

      {errors.length > 0 && (
        <div className="mt-4">
          <h3 className="text-sm font-semibold text-red-700 mb-2">
            {errors.length} Fehler:
          </h3>
          <ul className="text-sm space-y-1">
            {errors.map((err) => (
              <li key={err.fileName} className="border-l-2 border-red-300 pl-3 py-1">
                <div className="font-mono">{err.fileName}</div>
                <div className="text-kampmeyer-neutral-500 text-xs">{err.message}</div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
